import * as React from "react";
import { connect } from "react-redux";
import ConfirmationModal from "./ConfirmationModal";
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";
import MiniSpinner from "../common/MiniSpinner";
import { PROXY_APPROVED, PROXY_DECLINED, RX, EPIC, REQUESTV2, GRANT } from "../../constants/textConstants";
import moment from 'moment-timezone';
import * as ProxyHelper from "./ProxyHelper";
import { withRouter, Prompt } from 'react-router';
import ProxyStatus from './home/ProxyStatus';

const GRANTCANCELLEDNOTE = "the person granting access has cancelled the request";
const CANCELLEDNOTE = "The request was cancelled.";
const DOBCANCELLEDNOTE = "The date of birth provided in the request doesn't match your account.";
const DOBGENERALCANCELLEDNOTE = "The date of birth provided in the request doesn't match the recipient's account.";

class WaitingOnYou extends React.Component {
    constructor(props) {
        super(props);
        this.state = { decliningRequest: null };
    }

    componentDidMount() {
        const { proxySource } = this.props;
        if (proxySource && typeof proxySource !== 'undefined') {
            logUI(`MBHWeb.UI.${ProxyHelper.getLogProxySource(proxySource)}.WaitingOnYou.ComponentDidMount`, new Date(), Tools.getURLPath());
        }
    }

    onApprove(request) {
        const { onApprove, enableProxyRequestV2, enableProxyRXRequestAttestation, history } = this.props;
        const { RequestType, ProxyRequestId, ProxySource, FirstName } = request;
        //const encryptName = window && window.btoa(FirstName);  
        //logUI(`MBHWeb.UI.WaitingOnYou.Approve${ProxySource}${RequestType}`, new Date(), Tools.getURLPath(), JSON.stringify({ ProxyRequestId: ProxyRequestId }));
        if (enableProxyRXRequestAttestation || enableProxyRequestV2) {
            if (RequestType.toLowerCase() === GRANT) {
                logUI(`MBHWeb.UI.MySubjects.Approve${ProxyHelper.getLogProxySource(ProxySource)}Grant`, new Date(), Tools.getURLPath(), JSON.stringify({ ProxyRequestId: ProxyRequestId }));
            } else {
                logUI("MBHWeb.UI.MyProxies.ApproveProxyRequest", new Date(), Tools.getURLPath(), JSON.stringify({ ProxyRequestId: ProxyRequestId }));
            }
            history.push(`/proxymgmt?type=${RequestType.toLowerCase()}&source=${ProxySource.toLowerCase()}&action=accept&proxyRequestId=${ProxyRequestId}`);
        }
        //else if (enableProxyRequestV2 && RequestType.toLowerCase() === REQUESTV2 && history) {
        //    history.push(`/acceptProxyTermsV2/accept/${ProxyRequestId}/${ProxySource}/${RequestType}/${encryptName}`);
        //}
        else if (onApprove) {
            onApprove(request);
        }
    }

    onDecline(decliningRequest) {
        const { onDecline, declineProxyWithReason } = this.props;
        if (declineProxyWithReason) {
            if (onDecline) {
                onDecline(decliningRequest);
            }
        }
        else {
            this.setState({ decliningRequest });
        }
    }


    onDeclineConfirmed(yesDecline) {
        const { onDecline } = this.props;
        if (yesDecline) {
            if (onDecline) {
                onDecline(this.state.decliningRequest);
            }
        }
        this.setState({ decliningRequest: null });
    }


    render() {
        const { list, proxySource, actionType, declineProxyWithReason,
            approveRequestId, isApprovePending, approveErrorMessage, declineRequestId, isDeclinePending, grantPharmacyList, grantEpicList,
            declineErrorMessage, grantEpicExpiredList, hasGrantEpicExpiredList, grantEpicCancelledList, hasGrantEpicCancelledList,
            hasGrantPharmacyCancelledList, grantPharmacyCancelledList, hasGrantPharmacyExpiredList, grantPharmacyExpiredList, hasRequestEpicCancelledList, requestEpicCancelledList,
            hasRequestEpicDeclinedList, requestEpicDeclinedList, hasRequestEpicExpiredList, requestEpicExpiredList, hasRequestRxExpiredList, requestRxExpiredList,
            hasRequestRxDeclinedList, requestRxDeclinedList, hasRequestRxCancelledList, requestRxCancelledList } = this.props;
        const { decliningRequest } = this.state;
        const proxyRequestType = proxySource === RX ? "pharmacy" : "medical records";
        const spinnerForPending = (<div className="row overlay-loading-container">
            <div className="col-12 align-self-center">
                <MiniSpinner />
            </div>
        </div>);

        return (
            <React.Fragment>
                {list && list.map((request, index) =>
                (<div className="pending-proxy-list" key={index}>
                    <React.Fragment>
                        <ProxyStatus
                            iconColor="$color-primary-b1"
                            status={request.Status}
                            message={<>
                                {request.FirstName} {request.LastName} has requested access to your {proxyRequestType} account.
                                Please select an option to process this request.
                            </>}
                            link={{
                                label: "Approve",
                                onClick: () => this.onApprove(request)
                            }}
                            errorMsg={(actionType === PROXY_APPROVED)
                                ? (approveRequestId === request.ProxyRequestId
                                    ? (isApprovePending
                                        ? spinnerForPending : (approveErrorMessage)
                                            ? approveErrorMessage
                                            : "")
                                    : "")
                                : (actionType === PROXY_DECLINED)
                                    ? (declineRequestId === request.ProxyRequestId
                                        ? (isDeclinePending
                                            ? spinnerForPending : (declineErrorMessage)
                                                ? declineErrorMessage
                                                : "")
                                        : "")
                                    : ""
                            }
                            circleBtn={{
                                label: "Decline",
                                onClick: () => { this.onDecline(request) },
                                tooltipId: `decline-request-${index}`
                            }}
                        />
                    </React.Fragment>

                </div>)

                )}

                {/* grant pharmacy pending */}
                {grantPharmacyList && grantPharmacyList.map((grant, index) =>
                (<div className="pending-proxy-list" key={index}>
                    <React.Fragment>
                        <ProxyStatus
                            iconColor="$color-primary-b1"
                            status={grant.Status}
                            message={<>{grant.FirstName} {grant.LastName} invited you to access their pharmacy.
                                Please select an option to process this request. This invitation expires on <strong>{moment(grant.ExpireOn).format('MM/DD/YYYY')}.</strong></>}
                            link={{
                                label: "Approve",
                                onClick: () => this.onApprove(grant)
                            }}
                            errorMsg={(actionType === PROXY_APPROVED)
                                ? (approveRequestId === grant.ProxyRequestId
                                    ? (isApprovePending
                                        ? spinnerForPending : (approveErrorMessage)
                                            ? approveErrorMessage
                                            : "")
                                    : "")
                                : (actionType === PROXY_DECLINED)
                                    ? (declineRequestId === grant.ProxyRequestId
                                        ? (isDeclinePending
                                            ? spinnerForPending : (declineErrorMessage)
                                                ? declineErrorMessage
                                                : "")
                                        : "")
                                    : ""
                            }
                            circleBtn={{
                                label: "Decline",
                                onClick: () => { this.onDecline(grant) },
                                tooltipId: `decline-rx-grant-${index}`
                            }}
                        />
                    </React.Fragment>

                </div>)

                )}
                {/* grant medical records pending */}
                {grantEpicList && grantEpicList.map((grant, index) =>
                (<div className="pending-proxy-list" key={index}>
                    <React.Fragment>
                        <ProxyStatus
                            iconColor="$color-primary-b1"
                            status={grant.Status}
                            message={<>{grant.FirstName} {grant.LastName} invited you to access their medical records.
                                Please select an option to process this request. This invitation expires on <strong>{moment(grant.ExpireOn).format('MM/DD/YYYY')}.</strong></>}
                            link={{
                                label: "Approve",
                                onClick: () => this.onApprove(grant)
                            }}
                            errorMsg={(actionType === PROXY_APPROVED)
                                ? (approveRequestId === grant.ProxyRequestId
                                    ? (isApprovePending
                                        ? spinnerForPending : (approveErrorMessage)
                                            ? approveErrorMessage
                                            : "")
                                    : "")
                                : (actionType === PROXY_DECLINED)
                                    ? (declineRequestId === grant.ProxyRequestId
                                        ? (isDeclinePending
                                            ? spinnerForPending : (declineErrorMessage)
                                                ? declineErrorMessage
                                                : "")
                                        : "")
                                    : ""
                            }
                            circleBtn={{
                                label: "Decline",
                                onClick: () => { this.onDecline(grant) },
                                tooltipId: `decline-medical-grant-${index}`
                            }}
                        />
                    </React.Fragment>

                </div>)

                )}

                {/* request v2 medical records cancelled*/}
                {hasRequestEpicCancelledList && requestEpicCancelledList && requestEpicCancelledList.map((request, index) => {
                    const requestCancelledNote = request.FirstName + "'s request for medical record access has been cancelled.";
                    return (<div className="declined-proxy-list" key={index}>
                        <ProxyStatus
                            iconColor="$color-system-b1"
                            status={request.Status}
                            message={request.MessageNote && request.MessageNote.toLowerCase() !== requestCancelledNote.toLowerCase() && request.MessageNote.toLowerCase() !== CANCELLEDNOTE.toLowerCase()
                                ? <>
                                    {requestCancelledNote} {request.MessageNote}
                                </>
                                : <>
                                    {CANCELLEDNOTE}
                                </>
                            }
                        />
                    </div>)
                }
                )}

                {/* request v2 pharmacy records cancelled*/}
                {hasRequestRxCancelledList && requestRxCancelledList && requestRxCancelledList.map((request, index) => {
                    const requestCancelledNote = request.FirstName + "'s request for pharmacy access has been cancelled.";
                    return (<div className="declined-proxy-list" key={index}>
                        {request.MessageNote && request.MessageNote.toLowerCase() !== DOBCANCELLEDNOTE.toLowerCase() && request.MessageNote.toLowerCase() !== DOBGENERALCANCELLEDNOTE.toLowerCase() &&
                            <ProxyStatus
                                iconColor="$color-system-b1"
                                status={request.Status}
                                message={request.MessageNote && request.MessageNote.toLowerCase() !== requestCancelledNote.toLowerCase() && request.MessageNote.toLowerCase() !== CANCELLEDNOTE.toLowerCase() && request.MessageNote.toLowerCase().indexOf(GRANTCANCELLEDNOTE.toLowerCase()) === -1
                                    ? <>
                                        {requestCancelledNote} {request.MessageNote}
                                    </>
                                    : <>
                                        {CANCELLEDNOTE}
                                    </>
                                }
                            />
                        }
                    </div>);
                }
                )}

                {/* grant medical records cancelled*/}
                {hasGrantEpicCancelledList && grantEpicCancelledList && grantEpicCancelledList.map((grant, index) =>
                (<div className="declined-proxy-list" key={index}>
                    <ProxyStatus
                        iconColor="$color-system-b1"
                        status={grant.Status}
                        message={grant.MessageNote && grant.MessageNote.toLowerCase() !== GRANTCANCELLEDNOTE.toLowerCase() && grant.MessageNote.toLowerCase() !== CANCELLEDNOTE.toLowerCase()
                            ? <>
                                {grant.FirstName}'s invitation for account access has been cancelled. {grant.MessageNote}
                            </>
                            : <>
                                {CANCELLEDNOTE}
                            </>

                        }
                    />
                </div>)
                )}

                {/* grant pharmacy records cancelled*/}
                {hasGrantPharmacyCancelledList && grantPharmacyCancelledList && grantPharmacyCancelledList.map((grant, index) =>
                (<div className="declined-proxy-list" key={index}>
                    <ProxyStatus
                        iconColor="$color-system-b1"
                        status={grant.Status}
                        message={grant.MessageNote && grant.MessageNote.toLowerCase() !== GRANTCANCELLEDNOTE.toLowerCase() && grant.MessageNote.toLowerCase() !== CANCELLEDNOTE.toLowerCase()
                            ? <>
                                {grant.FirstName}'s invitation for account access has been cancelled. {grant.MessageNote}
                            </>
                            : <>
                                {CANCELLEDNOTE}
                            </>
                        }
                    />                  
                </div>)
                )}

                {/* request v2 medical records declined */
                /*Do not show Declined Requests to the Approver Task 80108: Approver Landing Page: Declined Request */}
                {/*hasRequestEpicDeclinedList && requestEpicDeclinedList && requestEpicDeclinedList.sort(this.latestFirst).map((request, index) =>
                    (<div className="proxy-declined" key={index}>
                        <span className="proxy-declined__label">{request.Status}: </span>
                        <span>You declined {request.Email}'s request for medical record access.</span>

                    </div>)
                )*/}


                {/* request v2 pharmacy records declined */
                /*Do not show Declined Requests to the Approver Task 80108: Approver Landing Page: Declined Request */}
                {/*hasRequestRxDeclinedList && requestRxDeclinedList && requestRxDeclinedList.sort(this.latestFirst).map((request, index) =>
                (<div className="proxy-declined" key={index}>
                    <span className="proxy-declined__label">{request.Status}: </span>
                    <span>You declined {request.Email}'s request for pharmacy access.</span>

                </div>)
                )*/}

                {/* grant medical records expired*/}
                {hasGrantEpicExpiredList && grantEpicExpiredList && grantEpicExpiredList.map((grant, index) =>
                (<div className="declined-proxy-list" key={index}>
                    <ProxyStatus
                        iconColor="$color-system-b1"
                        status={grant.Status}
                        message={<>
                            {grant.FirstName}'s invitation for account access has expired. You can ask for this invitation to be resent if you still need access.
                        </>}
                    />  
                </div>)
                )}

                {/* request v2 medical records expired*/}
                {hasRequestEpicExpiredList && requestEpicExpiredList && requestEpicExpiredList.map((request, index) =>
                (<div className="declined-proxy-list" key={index}>
                    <ProxyStatus
                        iconColor="$color-system-b1"
                        status={request.Status}
                        message={<>
                            {request.FirstName}'s request for medical record access has expired. It has been more than 30 days since it was sent.
                        </>}
                    />  
                </div>)
                )}

                {/* request v2 pharmacy records expired*/}
                {hasRequestRxExpiredList && requestRxExpiredList && requestRxExpiredList.map((request, index) =>
                (<div className="declined-proxy-list" key={index}>
                    <ProxyStatus
                        iconColor="$color-system-b1"
                        status={request.Status}
                        message={<>
                            {request.FirstName}'s request for pharmacy access has expired. It has been more than 30 days since it was sent.
                        </>}
                    />  
                </div>)
                )}


                {/* grant pharmacy records expired*/}
                {hasGrantPharmacyExpiredList && grantPharmacyExpiredList && grantPharmacyExpiredList.map((grant, index) =>
                (<div className="declined-proxy-list" key={index}>
                    <ProxyStatus
                        iconColor="$color-system-b1"
                        status={grant.Status}
                        message={<>
                            {grant.FirstName}'s invitation for account access has expired. You can ask for this invitation to be resent if you still need access.
                        </>}
                    /> 
                </div>)
                )}

                {decliningRequest && !declineProxyWithReason &&
                    <ConfirmationModal isOpen={decliningRequest !== null} onConfirmed={(yesDecline) => this.onDeclineConfirmed(yesDecline)}
                        message={`Are you sure you want to decline ${decliningRequest.FirstName}’s access to your pharmacy account?`}
                    />
                }
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        declineProxyWithReason: state.session.serverData ? state.session.serverData.declineProxyWithReason : false,
        enableProxyRequestV2: state.session.serverData ? state.session.serverData.enableProxyRequestV2 : false,
        enableProxyRXRequestAttestation: state.session.serverData ? state.session.serverData.enableProxyRXRequestAttestation : false
    };
};



export default withRouter(connect(mapStateToProps, null)(WaitingOnYou));